import Done from "@mui/icons-material/Done";
import Warning from "@mui/icons-material/Warning";
import {
  type AutocompleteRenderValueGetItemProps,
  Chip,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import type { FC } from "react";
import type { ChannelName } from "../../channels/types";
import type { RecipientPerson } from "../../recipients/server/supabase-recipient-service";

type Props = {
  channel: Pick<RecipientPerson, "id" | "display" | "destination" | "postability">;
  index: number;
  getTagProps: AutocompleteRenderValueGetItemProps<true>;
  service: ChannelName;
};

export const ChannelChip: FC<Props> = ({ channel, index, getTagProps, service }) => {
  if (service !== "slack")
    return (
      <Chip
        label={`${channel.display || channel.destination}`}
        {...getTagProps({ index })}
        key={channel.id}
      />
    );

  if (channel.postability === undefined) {
    return (
      <Tooltip key={index} arrow title="Checking if we can post to this channel...">
        <Chip
          icon={<CircularProgress size={20} />}
          label={`${channel.display || channel.destination}`}
          {...getTagProps({ index })}
          key={channel.id}
        />
      </Tooltip>
    );
  }

  if (channel.postability === true) {
    return (
      <Tooltip key={index} arrow title="Great news! We can post to this channel">
        <Chip
          icon={<Done />}
          label={`${channel.display || channel.destination}`}
          {...getTagProps({ index })}
          key={channel.id}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip key={index} arrow title="We can’t post to this channel">
      <Chip
        icon={<Warning />}
        label={`${channel.display || channel.destination}`}
        {...getTagProps({ index })}
        key={channel.id}
      />
    </Tooltip>
  );
};
